// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// Fixes an issue with filters not working on mobile
import Vue from 'vue'
import ElementUI from 'element-ui'
import Vant from 'vant'
import 'element-ui/lib/theme-chalk/index.css'
import 'vant/lib/index.css'
import './assets/style/init.scss'
import './assets/style/NVH5.scss'//全局H5移动端改版scss变量
import './assets/style/lowcode.scss'
import './assets/iconfont/iconfont.css'
ElementUI.Select.computed.readonly = function () {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode))
  return !(this.filterable || this.multiple || !isIE) && !this.visible
}

import App from './App'
import axios from 'axios'
import uploader from 'vue-simple-uploader'
import * as filters from './filters'
import store from './store/index'
import router from './router'
import HVH5Route from '@/router/nvh5route.js'
import '@/utils/dialogDrag.js'
import {Env_currentenv} from '../config/myglobalenvConfig.js'
import directive from '@/directive/index.js'

//import uedComs from '@uedcoms/vue' 
router.addRoutes(HVH5Route)
if(Env_currentenv=='production'){
  var _hmt = _hmt || []// 接入百度统计代码,勿删，正式环境需要
  window._hmt = _hmt;
  (function () {
    var hm = document.createElement('script')
    hm.src = 'https://hm.baidu.com/hm.js?b585d91a8a1e26bb07970ee44e240fa4'
    var s = document.getElementsByTagName('script')[0]
    s.parentNode.insertBefore(hm, s)
    console.log('统计')
  })()
}

// import  'lib-flexible'
//Vue.use(uedComs) //部分自己做的分页器组件库，和设计稿风格相符合版本必须是2.1.12及以上，其他版本打包有bug
Vue.use(ElementUI)
Vue.use(directive);
Vue.use(Vant)
Vue.use(uploader) // 上传插件
Vue.config.productionTip = false
Vue.prototype.$axios = axios
// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
//全局dialog
import Dialog from './components/globalDialog/index.js'
Vue.prototype.$globaldialog= Dialog

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App,
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js